
<template>
  <div>
    <draggable
      v-if="list.length > 0"
      v-bind="dragOptions"
      tag="div"
      class="widget-item-container mb-2"
      :list="list"
      :value="value"
      @input="inputEmit"
      @start="startEmit"
      @end="endEmit"
      swapThreshold="1"
    >
      <transition-group
        id="urunlerResimContainer"
        type="transition"
        class="d-flex flex-wrap"
        :name="!drag ? 'flip-list' : null"
      >
        <div
          class="list-group-item transparent px-2 py-2"
          v-for="(element, key) in list"
          :key="key"
        >
          <v-card color="grey lighten-3" width="260">
            <v-img :aspect-ratio="16 / 9" height="130" :src="getImg(key)" :key="getImg(key)">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="black lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card flat tile color="primary">
              <v-col class="py-2">
                <v-btn
                  fab
                  small
                  class="urun-resim-btn mr-2 elevation-0"
                  @click="resimOnizle(getImg(key))"
                >
                  <v-icon color="orange darken-4" small>mdi-eye</v-icon>
                </v-btn>
                <v-btn fab small class="urun-resim-btn elevation-0" @click="removeItem(element.id)">
                  <v-icon color="red darken-2" small>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-card>
            <p id="urun-resim-adi" class="text-captalize text-center">{{ element.name }}</p>
          </v-card>
        </div>
      </transition-group>
    </draggable>
    <div v-else>
      <p class="text-center text-overline grey--text py-5 grey lighten-3 mb-2">
        <v-icon small class="gorsel-eklenmedi-icon" left>mdi-alert</v-icon>{{$t('URUNLER.PRODUCT_IMAGE_OPERATIONS.NO_IMAGE_ADDITIONAL')}}
      </p>
    </div>
    <ResimOnizle :img="onizlemeResmi" @input="resimOnizleInput" />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ResimOnizle from "@/components/Modules/Urunler/ResimOnizle.vue";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "nested-test",
  display: "Transitions",
  data() {
    return {
      drag: false,
      src: [],
      onizlemeResmi: ""
    };
  },
  methods: {
    /**
     * @param key {Number}
     *
     * @returns {String}
     */
    getImg(key) {
      return this.src[key];
    },
    inputEmit(value) {
      this.$emit("input", value);
    },
    startEmit(value) {
      this.$emit("start", value);
    },
    endEmit(value) {
      this.$emit("end", value);
    },
    /**
     * Resim için bir önizleme ayarlaması yapar
     */
    getImgSrc(img, key) {
      return new Promise(resolve => {
        const picReader = new FileReader();
        picReader.onload = image => resolve(image.target.result);
        picReader.readAsDataURL(img);
      }).then(data => {
        this.$set(this.src, key, data);
      });
    },
    /**
     * Değişim gösteren datayı emitle
     */
    valueEmit(data) {
      this.$emit("change", data);
    },
    /**
     * Herhangi bir itemi sil
     */
    removeItem(itemID) {
      const items = _.remove(this.list, o => {
        return o.id !== itemID;
      });
      this.valueEmit(items);
    },
    /**
     * Resim önizlemesi tıklandığında açılacak overlay
     * için resim data:image sağlar
     */
    resimOnizle(resim) {
      this.onizlemeResmi = resim;
    },
    /**
     * Resim önizlede kapat tıklandığında
     * tekrar
     */
    resimOnizleInput(resim) {
      this.onizlemeResmi = resim;
    }
  },
  watch: {
    list: {
      handler(data) {
        this.list.forEach((img, key) => {
          this.src[key] = img.uploaded ? img.origin : img.url;
        });
        this.valueEmit(data);
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    draggable,
    ResimOnizle
  },
  computed: {
    ...mapState({
      autoSelects: state => state.Widget.Widgets.autoSelects
    }),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    }
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    },
  }
};
</script>

<style scoped>
.button {
  margin-top: 35px;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.urun-resim-btn {
  width: 30px;
  height: 30px;
}
#urun-resim-adi {
    line-height: 1.5em;
    padding: 0.5rem;
}
.gorsel-eklenmedi-icon {
  top: -2px;
}
</style>

